import { useTranslation } from "react-i18next";

import type { NotificationStatus } from "../types";
import { parseNotificationStatus } from "../utils";

import Tabs, { type TabItemProps } from "@/components/ui/v2/tabs";

type NotificationStatusTabsProps = {
  statuses: readonly NotificationStatus[];
  status: NotificationStatus;
  onChange: (status: NotificationStatus) => void;
};

export function NotificationStatusTabs({ statuses, status, onChange }: NotificationStatusTabsProps) {
  const { t } = useTranslation();

  const tabs: TabItemProps[] = statuses.map((value) => ({
    id: value,
    label: t(`notifications.status.${value}`),
    content: null,
  }));

  return (
    <Tabs
      tabs={tabs}
      activeTabId={status}
      onChange={(tab) => onChange(parseNotificationStatus(tab.id ?? null))}
    />
  );
}
